import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
@Component({
  selector: 'app-view-news',
  templateUrl: './view-news.component.html',
  styleUrls: ['./view-news.component.scss']
})
export class ViewNewsComponent {

newsDetails:any={};
newsdata: FirebaseObjectObservable<any>;
  constructor(private route: ActivatedRoute,  public router: Router, public af: AngularFireDatabase) {
  	 	 	this.route.params.map(params => params['id']).subscribe((Id) => {
  	 	 	 	console.log("id" + JSON.stringify(Id));
  	 	if(Id != null) {
        this.newsdata = this.af.object('/news/' + Id);
        this.newsdata.subscribe(
        (response) => { 
        	this.newsDetails = response;
           console.log("response" + JSON.stringify(response))
         }
      )
          }
       });
  }

}


// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/news/view-news/view-news.component.ts